import {initMixpanel} from 'common/report/tracking-setup';

function isMixpanelDefined() {
  return typeof mixpanel !== `undefined`;
}

let mixpanelInst = null;

if (isMixpanelDefined()) {
  mixpanelInst = initMixpanel(PROJECT_3_MIXPANEL_TOKEN);
  initMixpanel(MARKETING_MIXPANEL_TOKEN, `marketing`);
}

export const enum TrackingEvents {
  PlanBuilderLoaded = `Plan Builder Loaded`, // implemented
  PlanSelectionChanged = `Selected Plan Changed`, // implemented
  PurchasePlan = `Purchase Plan`, // implemented
  ChangePlan = `Upgrade/Downgrade Plan`, // implemented
  StepChanged = `Step Changed`, // implemented
  ErrorDisplayed = `Error Displayed in Plan Builder`, // implemented
  ContactUs = `Contact Us Request Click`, // implemented
  ContactSupport = `Contact Support`, // implemented
  VariantSelected = `Curve Variant Selected`, // implemented

  // Pricing 2023 events
  SliderCapUpdate = `Slider Cap Updated`,
  PackageAdded = `Package Added`,
  PackageRemoved = `Package Removed`,
  BillingFrequencyChanged = `Billing Frequency Changed`,
}

export const enum TrackingPropertyNames {
  AccountId = `Project owner billing account ID`,
  BillingCycle = `Selected MTU billing cycle`,
  ErrorMessage = `Error message`,
  PackagesMarketing = `MTU add-on packages`,
  PackagesProd = `MTU add-on packages selected`,
  PageVersion = `Page Version`,
  PlanTier = `Plan Tier`,
  PlanType = `Plan Type`,
  PlanValue = `Plan Value`,
  PlanTotalMTU = `Plan Total MTU`,
  CountryCode = `Billing country code`,
  PostalCode = `Billing postal code`,
  ResourceType = `Resource Type`,
  SelectedARR = `Selected event/MTU plan ARR`,
  SelectedVolume = `Selected event/MTU plan volume`,
  TaxQuoted = `Sales tax (quoted)`,
  UserId = `user_id`,
  SelectedStep = `Selected step`,
  CurveVariant = `Curve variant`,
  BillingFrequency = `Billing frequency`,
}

export const enum TrackingPropertyValues {
  PricingTest = `America's pricing test 2020`,
  MtuEnterprise = `MTU Enterprise`,
  MtuGrowthMarketing = `mtu_growth`,
  MtuGrowthProd = `MTU Growth`,
  MtuType = `MTU`,
  MtuStarter = `MTU Starter`,
  Original = `Original`,
}

export function mixpanelTrack(event: TrackingEvents, properties = {}): void {
  if (mixpanelInst) {
    mixpanelInst.track(event, properties);
  }
}

export function identify(userId: string): void {
  if (mixpanelInst) {
    mixpanel.identify(userId);
    mixpanel.marketing.identify(userId);
  }
}
